import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axios, { AxiosResponse } from 'axios';
import { toast } from 'react-toastify';
import ToastSuccess from 'src/components/atoms/toast/toast-success';

type TInitialState = {
  loading: boolean;
  success: boolean;
  failure: boolean;
  successMessage: string;
};

const initialState: TInitialState = {
  loading: false,
  success: false,
  failure: false,
  successMessage: null as unknown as string,
};

export const changePassword = createAsyncThunk(
  'change-password/put',
  async (data: { id: number; oldPassword: string; newPassword: string }, { rejectWithValue }) => {
    try {
      const response: AxiosResponse<string> = await axios.put(`/api/user/change-password`, data);

      toast(ToastSuccess('Password aggiornata con successo'));

      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

const passwordResetSlice = createSlice({
  name: 'passwordReset',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(changePassword.pending, (state): TInitialState => {
        return { ...state, loading: true, success: false, failure: false };
      })
      .addCase(changePassword.fulfilled, (state, action): TInitialState => {
        return {
          ...state,
          loading: false,
          success: true,
          successMessage: action.payload,
        };
      })
      .addCase(changePassword.rejected, (state): TInitialState => {
        return { ...state, loading: false, failure: true };
      });
  },
});

export default passwordResetSlice.reducer;
